module.exports = __webpack_public_path__ + "static/floral-small-d952256841a156028168d758f60b2baa.png";